import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from 'gatsby-image'
import Layout from "../components/layout"
import { graphql } from "gatsby"

import favicon from '../assets/images/favicon.ico'

import heroStyles from '../components/hero.module.css'
import blogStyles from './blog-post.module.css'
import global from "../pages/general.module.css";
import styles from '../components/navigation.module.css'

import { IoIosArrowRoundBack } from 'react-icons/io'

import { ga } from '../scripts'
import { FaTwitter, FaWhatsapp, FaFacebookSquare } from 'react-icons/fa'

class BlogPostTemplate extends React.Component {


  render() {

    const post = get(this.props, 'data.contentfulBlogPost')
    const text = post.description.childMarkdownRemark.html;

    let description = text.replace("<p>", "");
    description = description.replace("</p>", "");
    description = description.replace("<em>", "");
    description = description.replace("</em>", "");

    let body = post.body.childMarkdownRemark.html;

    body = body.replace("<a", `<a target="_blank"`);


    setTimeout(() => {
      if (typeof window !== 'undefined') {
        if (window["instgrm"]) {
          window["instgrm"].Embeds.process();
        }
      }
    }, 3000)


    const sharingText = encodeURIComponent(post.title);
    let url;

    if (typeof window !== 'undefined') {

      url = encodeURIComponent(window["location"].href)
    }

    const twitter = `https://twitter.com/intent/tweet/?text=${sharingText}&url=${url}`
    const fb = `https://www.facebook.com/sharer/sharer.php?u=${url}`
    const wp = `whatsapp://send?text=${sharingText}%20${url}`

    return (

      <Layout>
        <div style={{ background: '#fff' }}>
          <Helmet title={`${post.title} | Tasting Victoria`} >

            <link rel="icon" href={favicon} type="image/x-icon" />

            <meta property="og:title" content={`${post.title} | Tasting Victoria`} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={`${post.heroImage.sizes.src}`} />
            <meta name="p:domain_verify" content="c58f9149803b59b6aa361d8e60eb5690"/>

            {/* <script>{drift}</script>
          <script>{driftConfig}</script> */}

            {/* <!-- Global site tag (gtag.js) - Google Analytics --> */}
            <script async src="https://www.googletagmanager.com/gtag/js?id=UA-158051086-1"></script>
            <script>{ga}</script>

            <script type="text/javascript" src="https://a.omappapi.com/app/js/api.min.js" data-account="121742" data-user="109831" async></script>

            <script data-ad-client="ca-pub-7941469643015393" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>

          </Helmet>




          <div style={{ width: "100%", maxWidth: "1070px", margin: "0 auto" }}>
            <li className={styles.navigationItem}>
              <a href="/" className={styles.cta}>
                <IoIosArrowRoundBack className={styles.icon} color={"#85d2da"} size={18} style={{ top: "4px", position: "relative", marginRight: "2px" }} />
                Blog
            </a>
            </li>
          </div>



          <div className={`${blogStyles.body} ${global.withPadding} ${global.smallPadding}`}>

            <h1 className={`${blogStyles.title}`}>
              {post.title}
            </h1>

            <div className={blogStyles.author}>
              {/* <Img className={blogStyles.face} alt={post.author.name} sizes={post.author.image.sizes} /> */}

              <div className={blogStyles.authorTitle}>
                {/* <p>{post.author.name}</p> */}
                <p className={blogStyles.date}>{post.publishDate}</p>
              </div>
            </div>



            <div className={`${heroStyles.hero}`}>
              <Img className={heroStyles.heroImage} alt={post.title} sizes={post.heroImage.sizes} />
            </div>


            <div
              className="blogHtml"
              dangerouslySetInnerHTML={{
                __html: body,
              }}
            />

            <div className={`${blogStyles.footer}`}>

              <div className={blogStyles.authorBg}>
                <Img className={blogStyles.faceBg} alt={post.author.name} sizes={post.author.image.sizes} />

                <div className={blogStyles.authorTitleBg}>
                  <p className={blogStyles.written}>WRITTEN BY</p>
                  <p>{post.author.name}</p>
                  <p className={blogStyles.dateBg}>{post.author.company}</p>
                </div>
              </div>

              <div className={blogStyles.social}>

                <div>
                  <p>Share this post</p>
                </div>

                <div className={blogStyles.socialIcons}>
                  <a href={twitter} target="_blank" rel="noopener noreferrer">
                    <FaTwitter
                      color={"#373F49"}
                      size={26} />
                  </a>

                  <a href={fb} target="_blank" rel="noopener noreferrer">
                    <FaFacebookSquare
                      color={"#373F49"}
                      size={26} />
                  </a>

                  <a href={wp} target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp
                      color={"#373F49"}
                      size={26} />
                  </a>
                </div>

              </div>

            </div>
          </div>
        </div>
      </Layout>

    )
  }
}

export default BlogPostTemplate


export const pageQuery = graphql`
query BlogPostBySlug ($slug: String!) {
  contentfulBlogPost(slug: { eq: $slug }) {
    title
    author {
      title
      name
      company
      image {
        sizes(
          maxWidth: 1180
          maxHeight: 480
          resizingBehavior: PAD
          background: "rgb:000000"
        ) {
          ...GatsbyContentfulSizes_withWebp
        }
      }
    }
    publishDate(formatString: "MMMM Do, YYYY")
    heroImage {
      sizes(maxWidth: 1180, background: "rgb:000000", quality: 100) {
        ...GatsbyContentfulSizes_withWebp
      }
    }
    body {
      childMarkdownRemark {
        html
      }
    }
    description {
      childMarkdownRemark {
        html
      }
    }
  }
}`